import React from 'react';
import * as R from 'ramda';
import {convertConnectionTypesToServiceType} from '../../../../../../constants/utils/connectionTypes';

export const CheckboxCard = ({ labels, isSelected, service, serviceDatas, removeService, isFavorite, AddOrRemoveFromFavorites }) => {
  
    const progress = serviceDatas.some(s => s.serviceType === convertConnectionTypesToServiceType(service.connectionType)) ? 100 : 0;


    return (
        <>
            <div className="card-header card-media">
                <div className="card-target w-4 d-inherit text-center my-auto">
                    <img className="img-fluid m-auto py-1 w-4" src={service.icon} alt={service.title} />
                </div>
                <div className="media my-2">
                    <h3 className="card-target h5 o-40 text-uppercase font-weight-bolder my-auto mr-2">{service.title}</h3>
                    <div className="my-auto ml-auto">
                        <button type="button" className="btn btn-icon p-1 fs-sm bg-alert text-warning o-60--hover" onClick={() => AddOrRemoveFromFavorites(service.connectionType)}>
                            <i role="button" className={"eva align-middle" + (isFavorite ? " eva-star" : " eva-star-outline")}></i>
                        </button>

                        {/* <i role="button" className="eva eva-trash-2-outline mr-2 fs-root align-middle" onClick={() => AddOrRemove(service)}></i> */}
                        {/* <button type="button" className="btn btn-icon btn-options p-1 mr-n1" id={"dropdownMenuServiceoptions" + service} data-toggle="dropdown" data-reference="parent">
                            <i className="eva eva-more-vertical-outline fs-sm lh-1"></i>
                        </button>
                        <ul className="dropdown-menu z-max border-none shadow-xs" aria-labelledby={"dropdownMenuServiceoptions" + service}> 
                            <li><button className="dropdown-item px-3 fs-3" onClick={() => AddOrRemove(service)}><i className="eva eva-trash-2-outline mr-2 fs-root align-middle"></i><span className="o-70 align-middle">Supprimer</span></button></li>
                            <li><button className="dropdown-item px-3 fs-3"><i className="eva eva-star-outline mr-2 fs-root align-middle"></i><span className="o-70 align-middle">Préféré</span></button></li>
                        </ul> */}
                    </div>
                </div>
            </div>
            {
                isSelected ?
                    <div className="card-body pt-0">
                        {
                            !R.isNil(labels) && labels.length > 0 ?
                            <div className="mb-2">
                                {
                                    !R.isNil(labels) && labels.length > 0 && labels.map((label, index) => {
                                        return (<div key={index} className={"step-item" + (label.isActive ? ' active' : '')}><i className="eva eva-checkmark step-check mr-2"></i>{label.name}</div>)
                                    })
                                }
                            </div>
                            : ''
                        }
                        <hr className="w-auto mt-0" />
                        <div className={"progress position-relative mb-auto w-100 h-sm text-center rounded-max align-items-center" + (progress === 100 ? ' bg-white' : ' bg-common 0')}>
                            <div className={"progress-bar h-100 rounded-inherit" + (progress === 100 ? ' bg-success o-20' : ' gradient-prime o-50')} style={{ width: `${progress}%` }} role="progressbar"></div>
                            <div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (progress === 100 ? ' text-success' : ' o-80')} role="progressbar">{progress}%</div>
                        </div>
                    </div>
                    :
                    <div className="card-body pt-0">
                        <div className={"card-target progress position-relative mb-auto w-100 h-sm text-center rounded-max align-items-center" + (progress === 100 ? ' bg-white' : ' bg-common 0')}>
                            <div className={"progress-bar h-100 rounded-inherit" + (progress === 100 ? ' bg-success o-20' : ' gradient-prime o-50')} style={{ width: `${progress}%` }} role="progressbar"></div>
                            <div className={"position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (progress === 100 ? ' text-success' : ' o-80')} role="progressbar">{progress}%</div>
                        </div>
                    </div>
            }
            { isSelected &&
				<React.Fragment>
					<hr className="w-auto my-0" />
					<div className="card-footer p-1">
						<button type="button" className="btn btn-block bg-dim o-60 o-100--hover py-2" onClick={() => removeService()}>
							<i className="eva eva-trash-2-outline o-80 lh-1 mr-2 fs-root align-middle"></i><span className="o-70 align-middle">Supprimer</span>
						</button>
					</div>
			    </React.Fragment>
            }
        </>
    )
}